module.exports = __webpack_public_path__ + "img/fac9e1d.PNG";